/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取个人类型发票初始信息
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  orderId: string,
  orderType: "ORDER_TICKET" | "ORDER_GOOD" | "ORDER_VIDEO",

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: order.InvoiceAdvanceInfo;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/order/invoice-advance/personal/${orderId}/${orderType}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
